import instance from "../auth/axios";

// Get all sites for the authenticated user
const getUserSites = () => {
  return instance.get('/sites').then((response) => {
    if (response) {
      return response.data;
    }
  }).catch((error) => {
    console.error('Error fetching user sites:', error);
    throw error;
  });
};

// Get a specific site by ID
const getSiteById = (siteId) => {
  return instance.get(`/sites/${siteId}`).then((response) => {
    if (response) {
      return response.data;
    }
  }).catch((error) => {
    console.error('Error fetching site:', error);
    throw error;
  });
};

// Create a new site
const createSite = (siteData) => {
  return instance.post('/sites', siteData).then((response) => {
    if (response) {
      return response.data;
    }
  }).catch((error) => {
    console.error('Error creating site:', error);
    throw error;
  });
};

// Update a site
const updateSite = (siteId, siteData) => {
  return instance.put(`/sites/${siteId}`, siteData).then((response) => {
    if (response) {
      return response.data;
    }
  }).catch((error) => {
    console.error('Error updating site:', error);
    throw error;
  });
};

// Delete a site
const deleteSite = (siteId) => {
  return instance.delete(`/sites/${siteId}`).then((response) => {
    if (response) {
      return response.data;
    }
  }).catch((error) => {
    console.error('Error deleting site:', error);
    throw error;
  });
};

// Get site KPIs
const getSiteKpis = (siteId) => {
  return instance.get(`/sites/${siteId}/kpis`).then((response) => {
    if (response) {
      return response.data;
    }
  }).catch((error) => {
    console.error('Error fetching site KPIs:', error);
    throw error;
  });
};

// Get all sites KPIs
const getAllSitesKpis = () => {
  return instance.get('/sites/kpis').then((response) => {
    if (response) {
      return response.data;
    }
  }).catch((error) => {
    console.error('Error fetching all sites KPIs:', error);
    throw error;
  });
};

export {
  getUserSites,
  getSiteById,
  createSite,
  updateSite,
  deleteSite,
  getSiteKpis,
  getAllSitesKpis,
};
